export const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61559371991157'
export const LKD_URL = 'https://www.linkedin.com/company/staffea'
// export const CALENDLY_URL = 'https://calendly.com/m-mosquet/demo-staffea' // it will be back soon 🤞
export const CALENDLY_URL = 'https://calendly.com/staffea-demo/30min'

export const APP_STORE_URL = 'https://apps.apple.com/fr/app/staffea/id1645278874'
export const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.limengo.staffea&hl=fr'
